/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

import { MrfiktivHttpClientProvider } from "../../mrfiktiv-http-client.provider";
import { FleetManager } from "../../v1/FleetManager";

export class VehicleFleetService {
  /**
   * The proxy.
   */
  proxy: FleetManager;

  /**
   * @class Initialize ReportMeService
   */
  constructor(clientProvider: MrfiktivHttpClientProvider) {
    this.proxy = new FleetManager(clientProvider.client());
  }

  get(partnerId: string, fleetId: string) {
    return this.proxy.fleetManagerControllerFindAllChildrenForFleet(partnerId, fleetId);
  }
}

export default new VehicleFleetService(new MrfiktivHttpClientProvider());
